
// const Card = ({ 
//   children, 
//   title, 
//   subtitle, 
//   className = "",
//   variant = "default",
//   icon: Icon,
//   gradient = "from-blue-600 to-indigo-600",
//   compact = false,
//   actions,
//   loading = false,
//   onClick,
//   count,
//   hover = false
// }) => {
  
//   const renderHeader = () => {
//     if (variant === "gradient" && (title || subtitle)) {
//       return (
//         <div className={`bg-gradient-to-r ${gradient} ${compact ? 'p-4' : 'p-6'} relative overflow-hidden`}>
//           <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
          
//           <div className="relative z-10 flex items-center justify-between">
//             <div className="flex items-center gap-3">
//               {Icon && (
//                 <div className="inline-flex items-center justify-center w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl">
//                   <Icon className={`${compact ? 'w-5 h-5' : 'w-6 h-6'} text-white`} />
//                 </div>
//               )}
//               <div>
//                 {title && <h2 className={`${compact ? 'text-lg' : 'text-2xl'} font-bold text-white`}>{title}</h2>}
//                 {subtitle && <p className={`text-white/80 ${compact ? 'text-xs' : 'text-sm'} mt-1`}>{subtitle}</p>}
//               </div>
//             </div>
            
//             {actions && (
//               <div className="flex items-center gap-2">
//                 {actions}
//               </div>
//             )}
//           </div>
          
//           {/* Enhanced Decorative Elements */}
//           <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
//           <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
//           <div className="absolute top-4 right-20 w-8 h-8 bg-white/10 rounded-full"></div>
//         </div>
//       );
//     }
    
//     if (variant === "status" && (title || subtitle)) {
//       return (
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-4">
//             {Icon && (
//               <div className={`p-3 bg-gradient-to-r ${gradient} rounded-xl shadow-lg`}>
//                 <Icon className="w-6 h-6 text-white" />
//               </div>
//             )}
//             <div>
//               {title && <h3 className="font-bold text-slate-800 text-lg group-hover:text-blue-600 transition-colors duration-200">{title}</h3>}
//               {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
//             </div>
//           </div>
          
//           {count !== undefined && (
//             <div className="text-right">
//               <div className={`text-2xl font-bold ${loading ? 'animate-pulse' : ''} bg-gradient-to-r ${gradient} bg-clip-text text-transparent`}>
//                 {loading ? '...' : count}
//               </div>
//               <div className="text-xs text-slate-400">Total</div>
//             </div>
//           )}
//         </div>
//       );
//     }
    
//     if (variant === "default" && (title || subtitle)) {
//       return (
//         <div className="px-6 py-8 border-b border-gray-200">
//           {title && (
//             <h1 className="text-2xl font-bold text-gray-900 text-center">
//               {title}
//             </h1>
//           )}
//           {subtitle && (
//             <p className="mt-2 text-center text-gray-600">{subtitle}</p>
//           )}
//         </div>
//       );
//     }
    
//     return null;
//   };

//   const cardStyles = {
//     default: "bg-white rounded-xl shadow-sm",
//     gradient: "bg-white rounded-2xl shadow-xl border border-slate-200",
//     status: `bg-white rounded-xl shadow-lg border border-slate-200 ${hover ? 'hover:shadow-xl hover:-translate-y-1' : ''}`,
//     feature: "bg-white rounded-2xl shadow-xl border border-slate-200 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer"
//   };

//   const cardClasses = `${cardStyles[variant]} ${onClick ? 'cursor-pointer' : ''} ${hover ? 'transition-all duration-300 group' : ''} overflow-hidden ${className}`;

//   return (
//     <div className={cardClasses} onClick={onClick}>
//       {renderHeader()}
//       <div className={`${variant === "gradient" ? (compact ? "p-4" : "p-8") : variant === "status" ? "p-6" : "p-6 space-y-6"} ${loading ? 'animate-pulse' : ''}`}>
//         {variant === "status" && onClick && (
//           <div className="mt-4 flex items-center text-blue-600 text-sm font-medium group-hover:text-blue-700 transition-colors duration-200">
//             <span>Access Feature</span>
//             <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//             </svg>
//           </div>
//         )}
//         {children}
//       </div>
//     </div>
//   );
// };

// export default Card;
// Card.jsx - Enhanced Version
import React from "react";

export const Card = ({ 
  children, 
  title,
  subtitle,
  icon: Icon,
  className = "",
  variant = "default",
  actions,
  onClick,
  noPadding = false
}) => {
  
  const variants = {
    default: "bg-white border border-gray-200 shadow-sm",
    elevated: "bg-white border border-gray-200 shadow-lg",
    colored: "bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200",
    danger: "bg-red-50 border border-red-200",
    success: "bg-green-50 border border-green-200",
    warning: "bg-yellow-50 border border-yellow-200"
  };

  const cardClasses = `
    ${variants[variant]}
    rounded-lg transition-all duration-200
    ${onClick ? 'cursor-pointer hover:shadow-md' : ''}
    ${className}
  `;

  const renderHeader = () => {
    if (!title && !subtitle && !actions) return null;

    return (
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {Icon && (
              <div className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-600 rounded-lg">
                <Icon className="w-4 h-4" />
              </div>
            )}
            <div>
              {title && (
                <h3 className="text-lg font-semibold text-gray-900">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="text-sm text-gray-500 mt-1">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={cardClasses} onClick={onClick}>
      {renderHeader()}
      <div className={noPadding ? "" : "p-6"}>
        {children}
      </div>
    </div>
  );
};

// Status Card for dashboards
export const StatusCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  color = "blue",
  className = "" 
}) => {
  const colors = {
    blue: "text-blue-600 bg-blue-100",
    green: "text-green-600 bg-green-100",
    red: "text-red-600 bg-red-100",
    yellow: "text-yellow-600 bg-yellow-100",
    purple: "text-purple-600 bg-purple-100"
  };

  return (
    <Card className={className}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {trend && (
            <p className={`text-sm ${trend.positive ? 'text-green-600' : 'text-red-600'}`}>
              {trend.value}
            </p>
          )}
        </div>
        {Icon && (
          <div className={`p-3 rounded-lg ${colors[color]}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </Card>
  );
};
export default Card;